// @todo: Translations

const SOLR_SEARCH_REST_CONFIG_APPEARANCES = {
  endpoint: `/api/search/appearances`,
  pageMode: "endless", // endless or pager or none
  search: true,
  fields: [],
  facets: [
    {
      id: "appearance_weekday",
      isFrontendId: true,
      label: "Weekday",
      type: "inline_select",
      multiple: false,
      tag: ["inline"]
    },
    {
      id: "appearance_event_type",
      label: "Type",
      type: "select",
      multiple: true,
      tag: ["modal", "conference"]
    },
    {
      id: "appearance_participant_category",
      label: "Type of Event",
      type: "select",
      multiple: true,
      tag: ["modal", "music"]
    },
    {
      id: "appearance_format",
      label: "Format",
      type: "select",
      multiple: true,
      tag: ["modal", "conference"]
    },
    {
      id: "appearance_main_topic",
      label: "Session Topic",
      type: "select",
      multiple: true,
      tag: ["modal", "conference"]
    },
    {
      id: "appearance_genre",
      label: "Genre",
      type: "select",
      multiple: true,
      tag: ["modal", "music"]
    },
    {
      id: "appearance_spoken_language",
      label: "Spoken Language",
      type: "select",
      multiple: true,
      tag: ["modal", "conference"]
    },
    {
      id: "appearance_accessibility",
      isFrontendId: true,
      label: "Accessibility",
      type: "select",
      multiple: true,
      tag: ["modal", "music"]
    },
    {
      id: "appearance_accessibility",
      isFrontendId: true,
      label: "Accessibility",
      type: "select",
      multiple: true,
      tag: ["modal", "conference"]
    },
    {
      id: "appearance_time",
      label: "Time",
      type: "scroll_to",
      multiple: false,
      tag: ["inline"]
    },
    /* {
      id: "appearance_venue",
      label: "Venue",
      type: "scroll_to",
      multiple: false,
      tag: ["inline"]
    } */
  ],
  sorting: [
    {
      id: "date_start",
      order: "asc",
      label: "time",
      tag: "inline",
      default: true,
    }, {
      id: "venue_location_name",
      order: "asc",
      label: "venue",
      tag: "inline"
    }
  ],
  presetFilters: [],
  pagerSize: 9,
};

export default SOLR_SEARCH_REST_CONFIG_APPEARANCES;
